/* AbNoor — cart: quantity, remove, note. Ajax with a full-reload fallback. */
(function () {
  'use strict';

  function root() { return document.querySelector('[data-abnoor-cart]'); }
  function cartRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }

  function init(el) {
    if (!el || el.dataset.abnoorReady === '1') return;
    el.dataset.abnoorReady = '1';

    var sectionId = el.dataset.sectionId;

    /* Swap our section's markup for the freshly rendered one. */
    function repaint(html) {
      if (!html) { window.location.reload(); return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-abnoor-cart]');
      var cur = root();
      if (!next || !cur) { window.location.reload(); return; }
      cur.replaceWith(next);
      init(root());
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    function change(line, quantity, lineEl) {
      if (lineEl) lineEl.classList.add('is-busy');
      fetch(cartRoot() + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: sectionId })
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      }).then(function (data) {
        var html = data && data.sections && data.sections[sectionId];
        repaint(html);
      }).catch(function (err) {
        console.warn('[abnoor cart] change failed, reloading:', err);
        window.location.reload();
      });
    }

    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-qty]');
      if (!btn || !el.contains(btn)) return;
      e.preventDefault();
      change(btn.dataset.line, btn.dataset.cartQty, btn.closest('[data-cart-line]'));
    });

    var noteBtn = el.querySelector('[data-cart-notebtn]');
    var noteWrap = el.querySelector('[data-cart-note]');
    if (noteBtn && noteWrap) {
      noteBtn.addEventListener('click', function () {
        var open = !noteWrap.hidden;
        noteWrap.hidden = open;
        noteBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        noteBtn.textContent = open ? 'Add a note' : 'Hide note';
        if (!open) {
          var ta = noteWrap.querySelector('textarea');
          if (ta) ta.focus();
        }
      });
    }

    var note = el.querySelector('#CartNote');
    var noteState = el.querySelector('[data-cart-notestate]');
    if (note) {
      var timer = null;
      var save = function () {
        if (noteState) noteState.textContent = 'Saving…';
        fetch(cartRoot() + '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).then(function (res) {
          if (noteState) noteState.textContent = res.ok ? 'Saved' : 'Not saved — try again';
        }).catch(function () {
          if (noteState) noteState.textContent = 'Not saved — try again';
        });
      };
      note.addEventListener('input', function () {
        clearTimeout(timer);
        if (noteState) noteState.textContent = '';
        timer = setTimeout(save, 700);
      });
      note.addEventListener('blur', function () { clearTimeout(timer); save(); });
    }

    /* Checkout. The form POST to /cart with name="checkout" is the no-JS path.
       When JS is available we skip it: save any pending note, then go straight
       to /checkout. A form post can be swallowed by a wrapping form or by the
       button's name/value being dropped — a direct navigation cannot. */
    var form = el.querySelector('[data-cart-form]');
    var checkout = el.querySelector('[data-cart-checkout]');
    if (checkout) {
      var label = el.querySelector('[data-cart-checkoutlabel]');
      var restore = function () {
        checkout.disabled = false;
        if (label) label.textContent = checkout.getAttribute('data-label') || 'Checkout';
      };
      var go = function () {
        checkout.disabled = true;
        if (label) label.textContent = 'Taking you to checkout…';
        setTimeout(restore, 10000);
        window.location.href = cartRoot() + '/checkout';
      };

      checkout.addEventListener('click', function (e) {
        e.preventDefault();
        var ta = el.querySelector('#CartNote');
        if (!ta) { go(); return; }
        /* Flush the note first, but never let it block checkout. */
        var done = false;
        var once = function () { if (!done) { done = true; go(); } };
        setTimeout(once, 1200);
        fetch(cartRoot() + '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: ta.value })
        }).then(once).catch(once);
      });

      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });
      window.addEventListener('pageshow', restore);
    }
  }

  function boot() { init(root()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
